import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { QuoteProvider } from "@/components/site/QuoteContext";
import { Nav } from "@/components/site/Nav";
import { Footer } from "@/components/site/Footer";
import { StatementPopup } from "@/components/site/StatementPopup";
import { TalkBubble } from "@/components/site/TalkBubble";
import { ReferralPopup } from "@/components/site/ReferralPopup";
import Home from "@/pages/Home";
import Solutions from "@/pages/Solutions";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import SignIn from "@/pages/SignIn";
import SupportIndex from "@/pages/SupportIndex";
import SupportDetail from "@/pages/SupportDetail";

const SmoothScroll = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); };
  }, []);
  useEffect(() => {
    if (!hash) {
      window.__lenis?.scrollTo(0, { immediate: true });
      window.scrollTo(0, 0);
      return undefined;
    }
    const t = setTimeout(() => {
      const el = document.getElementById(hash.slice(1));
      if (!el) return;
      if (window.__lenis) window.__lenis.scrollTo(el, { offset: -110 });
      else el.scrollIntoView({ behavior: "smooth" });
    }, 350);
    return () => clearTimeout(t);
  }, [pathname, hash]);
  return null;
};

const Site = ({ children }) => (
  <>
    <Nav />
    <main>{children}</main>
    <Footer />
    <StatementPopup />
    <TalkBubble />
    <ReferralPopup />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <QuoteProvider>
          <SmoothScroll />
          <Routes>
            <Route path="/" element={<Site><Home /></Site>} />
            <Route path="/solutions" element={<Site><Solutions /></Site>} />
            <Route path="/about" element={<Site><About /></Site>} />
            <Route path="/contact" element={<Site><Contact /></Site>} />
            <Route path="/support" element={<Site><SupportIndex /></Site>} />
            <Route path="/support/:slug" element={<Site><SupportDetail /></Site>} />
            <Route path="/sign-in" element={<Site><SignIn /></Site>} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <Toaster position="bottom-right" richColors />
        </QuoteProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
